var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{staticClass:"crly-m-contents-category-list",attrs:{"options":_vm.swiperOption},on:{"clickSlide":_vm.onSwiperClickSlide}},[_vm._l((_vm.itemList),function(item){return [_c('swiper-slide',{key:item.class,staticClass:"crly-icon",class:[item.class, { on: _vm.type == item.class }]},[_c('span',{staticClass:"crly-icon-txt"})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }